import * as React from 'react';
import tvOSSelected from '../../../assets/tvos-selected.svg';
import tvOSUnselected from '../../../assets/tvos-unselected.svg';
import tvOSDisabledSelected from '../../../assets/tvos-disabled-selected.svg';
import tvOSDisabledUnselected from '../../../assets/tvos-disabled-unselected.svg';
import { IconProps } from '../../typescriptHelpers';

interface TvOSIconProps extends IconProps {
    isSelected: boolean;
    isDisabledTreatment: boolean;
}

const TvOSIcon: React.FC<TvOSIconProps> = (props: TvOSIconProps) => {
    let sourceImage = props.isSelected ? tvOSSelected : tvOSUnselected;
    if (props.isDisabledTreatment) {
        sourceImage = props.isSelected ? tvOSDisabledSelected : tvOSDisabledUnselected;
    }

    return <img src={sourceImage} width={props.width} height={props.height} />;
};

export default TvOSIcon;
